import React from 'react';
import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import ValueProposition from './components/ValueProposition';
import FAQ from './components/FAQ';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Hero />
      <About />
      <ValueProposition />
      <FAQ />
      <Contact />
    </div>
  );
}

export default App;
